import gql from 'graphql-tag';

export default gql`
	mutation AccountContactAdd($contact_name: String, $contact_tel: String) {
		accountContactAdd(contact_name: $contact_name, contact_tel: $contact_tel) {
			_id
		}
	}
`;
